import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  AdminViewAllOrders,
  AllAdminProducts,
  getAllBNPL,
  GetAllCarts,
  GetAllEvents,
  getCategories,
  getTransactions,
} from "../utils/Api/ApiCalls";
import { BarChart } from "@mui/x-charts";
import { Link } from "react-router-dom";

const DashboardIndex = () => {
  const [date, setDate] = useState(new Date());
  const [productData, setProductData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [revenue, setRevenue] = useState(0);
  const [monthlyEarning, setMonthlyEarning] = useState(0);
  const [bnplCount, setBnplCount] = useState(0);
  const [whatsappRedirects, setWhatsappRedirects] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [pendingCarts, setPendingCarts] = useState([]);
  const itemsPerPage = 5;

  const [orderData, setOrderData] = useState([]);

  const fetchingOrdersAndProducts = async () => {
    try {
      const orders = await AdminViewAllOrders();

      const filteredOrders = orders.data.filter((order) => {
        return order.status === "success";
      });
      setOrderData(filteredOrders);

      var totalPurchase = 0;
      for (let index = 0; index < filteredOrders?.length; index++) {
        totalPurchase += filteredOrders[index].amount;
      }
      setRevenue(totalPurchase.toLocaleString());

      const products = await AllAdminProducts();
      setProductData(products.data);

      const categoriesData = await getCategories();
      setCategories(categoriesData.categories);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  // Calculate monthly earning.....
  const calculateMonthlyEarning = (orders) => {
    var monthlyEarning = 0;
    // filter the array my month and year...
    const filteredOrders = orders.filter((order) => {
      var orderDate = new Date(order.createdDate);
      var orderMonth = orderDate.getMonth();
      var orderYear = orderDate.getFullYear();

      return orderMonth === date.getMonth() && orderYear === date.getFullYear();
    });
    // summing up the amounts...
    var totalPurchase = 0;
    for (let index = 0; index < filteredOrders?.length; index++) {
      totalPurchase += filteredOrders[index].amount;
    }
    setMonthlyEarning(totalPurchase.toLocaleString());
  };

  const getAllTransactions = async () => {
    const transactionData = await getTransactions();
    setTransactions(transactionData?.transactions);
  };

  const getBnplReq = async () => {
    const bnplData = await getAllBNPL();
    console.log(bnplData?.data);

    setBnplCount(bnplData?.data?.length);
  };
  const getEvents = async () => {
    const eventsData = await GetAllEvents();
    const waData = eventsData?.filter((event) => {
      return event.eventName?.toLowerCase() === "whatsapp";
    });

    console.log(eventsData);

    const now = new Date();
    // Helper functions for date comparisons
    const isSameDay = (date1, date2) =>
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();

    const isSameWeek = (date1, date2) => {
      const startOfWeek = new Date(date2);
      startOfWeek.setDate(date2.getDate() - date2.getDay());
      startOfWeek.setHours(0, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);

      return date1 >= startOfWeek && date1 <= endOfWeek;
    };

    const isSameMonth = (date1, date2) =>
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth();

    const eventsByTime = {
      today: [],
      thisWeek: [],
      thisMonth: [],
    };

    waData?.forEach((event) => {
      const eventDate = new Date(event.timestamp);

      if (isSameDay(eventDate, now)) {
        eventsByTime.today.push(event);
      }

      if (isSameWeek(eventDate, now)) {
        eventsByTime.thisWeek.push(event);
      }

      if (isSameMonth(eventDate, now)) {
        eventsByTime.thisMonth.push(event);
      }
    });

    setWhatsappRedirects(eventsByTime?.thisMonth?.length);
  };
  const getCarts = async () => {
    const cartsData = await GetAllCarts();
    // const waData = eventsData.filter((event) => {
    //   return event.eventName.toLowerCase() === "whatsapp";
    //   });
    console.log(cartsData?.carts);

    setPendingCarts(cartsData?.carts.length);
  };

  useEffect(() => {
    fetchingOrdersAndProducts();
    getAllTransactions();
    getBnplReq();
    getEvents();
    getCarts();
  }, []);

  useEffect(() => {
    calculateMonthlyEarning(orderData);
  }, [orderData]);

  const parseDate = (date) => {
    const newDate = new Date(date);
    return newDate.toDateString();
  };

  // Calculate the range of items to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = productData?.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Go to the previous page
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // const onCatgeoryChange = (e) => {
  //   const { name, value } = e.target;
  //   // setTemp({});
  //    if(value !== "all"){

  //   let data = temp.filter((item, i) => item["product_data"].category.includes(value));

  //   setOrderData(data);
  //    }else{
  //      setOrderData(temp);
  //    }
  // }

  // const dataset = transactions.map((transaction) => {
  //   return {
  //     PaymentMethod: transaction.PaymentMethod,
  //   };
  // });

  // const chartSetting = {
  //   xAxis: [
  //     {
  //       label: "Amount",
  //     },
  //   ],
  //   yAxis: [
  //     {
  //       scaleType: "band",
  //       dataKey: "PaymentMethod",
  //     },
  //   ],
  //   width: 300,
  //   height: 200,
  // };

  const valueFormatter = (value) => `$${value.toFixed(2)}`;
  return (
    <>
      <section class="content-main">
        <div class="content-header">
          <div>
            <h2 class="content-title card-title">Dashboard</h2>
            <p>Whole data about your business here</p>
          </div>
          <div>
            <a href="add-product" class="btn btn-primary">
              <i class="text-muted material-icons md-post_add"></i>Add product
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <div class="card card-body mb-4">
              <article class="icontext">
                <span class="icon icon-sm rounded-circle bg-primary-light">
                  <i class="text-primary material-icons md-monetization_on"></i>
                </span>
                <div class="text">
                  <h6 class="mb-1 card-title">Revenue</h6>
                  {/* <span>$13,456.5</span> */}
                  <span>₦{revenue}</span>
                  <span class="text-sm"> Shipping fees are not included </span>
                </div>
              </article>
            </div>
          </div>
          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="/orders">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-success-light">
                    <i class="text-success material-icons md-local_shipping"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">Orders</h6>
                    {/* <span>53.668</span> */}
                    <span>{orderData?.length}</span>
                    <span class="text-sm"> Excluding orders in transit </span>
                  </div>
                </article>
              </div>
            </Link>
          </div>
          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="/products">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-warning-light">
                    <i class="text-warning material-icons md-qr_code"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">Products</h6>
                    {/* <span>9.856</span> */}
                    <span>{productData?.length}</span>
                    <span class="text-sm">
                      In {categories?.length} Categories
                    </span>
                  </div>
                </article>
              </div>
            </Link>
          </div>

          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="monthly-earnings">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-info-light">
                    <i class="text-info material-icons md-shopping_basket"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">Monthly Earning</h6>
                    {/* <span>₦6,982</span> */}
                    <span>₦{monthlyEarning}</span>
                    <span class="text-sm"> Based in your local time. </span>
                  </div>
                </article>
              </div>
            </Link>
          </div>

          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="/home-layout">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-info-light">
                    <i class="text-info material-icons md-shopping_basket"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">Home Layout</h6>
                  </div>
                </article>
              </div>
            </Link>
          </div>

          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="bnpl">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-info-light">
                    <i class="text-info material-icons md-shopping_basket"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">BNPL Requests</h6>
                    {/* <span>₦6,982</span> */}
                    <span>{bnplCount || 0}</span>
                    {/* <span class="text-sm"> Based in your local time. </span> */}
                  </div>
                </article>
              </div>
            </Link>
          </div>
          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="tracker">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-info-light">
                    <i class="text-info material-icons md-whatsapp"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">Whatsapp Redirects</h6>
                    {/* <span>₦6,982</span> */}
                    <span>{whatsappRedirects || 0}</span>
                    {/* <span class="text-sm"> Based in your local time. </span> */}
                  </div>
                </article>
              </div>
            </Link>
          </div>

          <div class="col-lg-3" style={{ cursor: "pointer" }}>
            <Link to="tracker/cart">
              <div class="card card-body mb-4">
                <article class="icontext">
                  <span class="icon icon-sm rounded-circle bg-info-light">
                    <i class="text-info material-icons md-whatsapp"></i>
                  </span>
                  <div class="text">
                    <h6 class="mb-1 card-title">Pending carts</h6>
                    {/* <span>₦6,982</span> */}
                    <span>{pendingCarts || 0}</span>
                    {/* <span class="text-sm"> Based in your local time. </span> */}
                  </div>
                </article>
              </div>{" "}
            </Link>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-8 col-lg-12">
            <div class="card mb-4">
              <article class="card-body">
                <h5 class="card-title">Sale statistics</h5>
                <p>This the Chart display</p>
                {/* <BarChart
                  xAxis={[
                    {
                      scaleType: "band",
                      data: ["group A", "group B", "group C"],
                    },
                  ]}
                  series={[
                    { data: [4, 3, 5] },
                  ]}
                  width={500}
                  height={300}
                /> */}
                <canvas
                  id="myChart"
                  style={{
                    height: "120px",
                  }}
                >
                  Chats
                </canvas>
              </article>
            </div>
            {/* <div class="row">
              <div class="col-lg-5">
                <div class="card mb-4">
                  <article class="card-body">
                    <h5 class="card-title">New Members</h5>
                    <div class="new-member-list">
                      <div class="d-flex align-items-center justify-content-between mb-4">
                        <div class="d-flex align-items-center">
                          <img
                            src="assets/imgs/people/avatar-4.png"
                            alt=""
                            class="avatar"
                          />
                          <div>
                            <h6>Patric Adams</h6>
                            <p class="text-muted font-xs">Sanfrancisco</p>
                          </div>
                        </div>
                        <a href="#" class="btn btn-xs">
                          <i class="material-icons md-add"></i> Add
                        </a>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-4">
                        <div class="d-flex align-items-center">
                          <img
                            src="assets/imgs/people/avatar-2.png"
                            alt=""
                            class="avatar"
                          />
                          <div>
                            <h6>Dilan Specter</h6>
                            <p class="text-muted font-xs">Sanfrancisco</p>
                          </div>
                        </div>
                        <a href="#" class="btn btn-xs">
                          <i class="material-icons md-add"></i> Add
                        </a>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-4">
                        <div class="d-flex align-items-center">
                          <img
                            src="assets/imgs/people/avatar-3.png"
                            alt=""
                            class="avatar"
                          />
                          <div>
                            <h6>Tomas Baker</h6>
                            <p class="text-muted font-xs">Sanfrancisco</p>
                          </div>
                        </div>
                        <a href="#" class="btn btn-xs">
                          <i class="material-icons md-add"></i> Add
                        </a>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
              <div class="col-lg-7">
                <div class="card mb-4">
                  <article class="card-body">
                    <h5 class="card-title">Recent activities</h5>
                    <ul class="verti-timeline list-unstyled font-sm">
                      <li class="event-list">
                        <div class="event-timeline-dot">
                          <i class="material-icons md-play_circle_outline font-xxl"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <h6>
                              <span>Today</span>
                              <i class="material-icons md-trending_flat text-brand ml-15 d-inline-block"></i>
                            </h6>
                          </div>
                          <div class="media-body">
                            <div>Lorem ipsum dolor sit amet consectetur</div>
                          </div>
                        </div>
                      </li>
                      <li class="event-list active">
                        <div class="event-timeline-dot">
                          <i class="material-icons md-play_circle_outline font-xxl animation-fade-right"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <h6>
                              <span>17 May</span>
                              <i class="material-icons md-trending_flat text-brand ml-15 d-inline-block"></i>
                            </h6>
                          </div>
                          <div class="media-body">
                            <div>
                              Debitis nesciunt voluptatum dicta reprehenderit
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="event-list">
                        <div class="event-timeline-dot">
                          <i class="material-icons md-play_circle_outline font-xxl"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <h6>
                              <span>13 May</span>
                              <i class="material-icons md-trending_flat text-brand ml-15 d-inline-block"></i>
                            </h6>
                          </div>
                          <div class="media-body">
                            <div>Accusamus voluptatibus voluptas.</div>
                          </div>
                        </div>
                      </li>
                      <li class="event-list">
                        <div class="event-timeline-dot">
                          <i class="material-icons md-play_circle_outline font-xxl"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <h6>
                              <span>05 April</span>
                              <i class="material-icons md-trending_flat text-brand ml-15 d-inline-block"></i>
                            </h6>
                          </div>
                          <div class="media-body">
                            <div>
                              At vero eos et accusamus et iusto odio dignissi
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="event-list">
                        <div class="event-timeline-dot">
                          <i class="material-icons md-play_circle_outline font-xxl"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <h6>
                              <span>26 Mar</span>
                              <i class="material-icons md-trending_flat text-brand ml-15 d-inline-block"></i>
                            </h6>
                          </div>
                          <div class="media-body">
                            <div>Responded to need “Volunteer Activities</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </article>
                </div>
              </div>
            </div> */}
          </div>
          <div class="col-xl-4 col-lg-12">
            <div class="card mb-4">
              <article class="card-body">
                <h5 class="card-title">Payment Method</h5>
                <p>This the Chart display</p>
                {/* <BarChart
                  dataset={dataset}
                  xAxis={[{ dataKey: "Amount" }]}
                  yAxis={[{ scaleType: "band", dataKey: "PaymentMethod" }]}
                  series={[
                    {
                      dataKey: "Amount",
                      label: "Transaction Amount",
                      valueFormatter,
                    },
                  ]}
                  layout="horizontal"
                  {...chartSetting}
                /> */}
                <canvas id="myChart2" height="217"></canvas>
              </article>
            </div>
            {/* <div class="card mb-4">
              <article class="card-body">
                <h5 class="card-title">Marketing Chanel</h5>
                <span class="text-muted font-xs">Facebook</span>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{
                      width: "15%",
                    }}
                  >
                    15%
                  </div>
                </div>
                <span class="text-muted font-xs">Instagram</span>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{
                      width: "65%",
                    }}
                  >
                    65%
                  </div>
                </div>
                <span class="text-muted font-xs">Google</span>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{
                      width: "51%",
                    }}
                  >
                    51%
                  </div>
                </div>
                <span class="text-muted font-xs">Twitter</span>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{
                      width: "80%",
                    }}
                  >
                    80%
                  </div>
                </div>
                <span class="text-muted font-xs">Other</span>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{ width: "80%" }}
                  >
                    80%
                  </div>
                </div>
              </article>
            </div> */}
          </div>
        </div>
        <div class="card mb-4">
          <header class="card-header">
            <h4 class="card-title">Latest orders</h4>
            <div class="row align-items-center">
              <div class="col-md-3 col-12 me-auto mb-md-0 mb-3">
                <div class="custom_select">
                  <select class="form-select select-nice">
                    {" "}
                    {/*onChange={onCatgeoryChange} */}
                    <option value="all">All Categories</option>
                    {categories?.map((category, i) => (
                      <option
                        key={"category" + i}
                        value={category.categoryName}
                      >
                        {category.categoryName}
                      </option>
                    ))}
                    {/* <option>Women's Clothing</option>
                    <option>Men's Clothing</option>
                    <option>Cellphones</option>
                    <option>Computer & Office</option>
                    <option>Consumer Electronics</option>
                    <option>Jewelry & Accessories</option>
                    <option>Home & Garden</option>
                    <option>Luggage & Bags</option>
                    <option>Shoes</option>
                    <option>Mother & Kids</option> */}
                  </select>
                </div>
              </div>
              <div class="col-md-2 col-6">
                {/* <input type="date" value="02.05.2021" class="form-control" /> */}
              </div>
              <div class="col-md-2 col-6">
                {/* <div class="custom_select">
                  <select class="form-select select-nice">
                    <option selected>Status</option>
                    <option>All</option>
                    <option>Paid</option>
                    <option>Chargeback</option>
                    <option>Refund</option>
                  </select>
                </div> */}
              </div>
            </div>
          </header>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#ID</th>
                    <th scope="col">Product Name</th>
                    {/* <th scope="col">Image</th> */}
                    <th scope="col">Total</th>
                    <th scope="col">Status</th>
                    <th scope="col">Date</th>
                    <th scope="col" class="text-end">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.length >= 1 ? (
                    <>
                      {orderData?.map((props, i) => (
                        <tr key={props.ID}>
                          <td>{i + 1}</td>
                          {/* <td>{props["product_data"]?.productTitle}</td> */}
                          <td>
                            <div className="order-items">
                              {props?.orderItems?.length === 0 ? (
                                <span>No items...</span>
                              ) : (
                                props.orderItems.map((item, index) => (
                                  <React.Fragment key={index}>
                                    <span>{item.productName || "- - - -"}</span>
                                    <br />
                                  </React.Fragment>
                                ))
                              )}
                            </div>
                          </td>
                          {/* <td>marvin@example.com</td> */}
                          {/* product images... */}
                          {/* <td>
                            {" "}
                            <img
                              style={{ width: "40px", height: "30px" }}
                              // src={`http://localhost:7045/uploads/${props["product_data"]?.productImages[0].img}`}
                              src={`https://backend.argone.ng/uploads/${props["product_data"]?.productImages[0].img}`}
                              alt="#"
                            />
                          </td> */}
                          <td>{props.amount.toLocaleString()}</td>
                          <td>
                            <span class="badge rounded-pill alert-success">
                              {props.status}
                            </span>
                          </td>
                          <td>{parseDate(props.createdDate)}</td>
                          <td class="text-end">
                            {/* <a href="#" class="btn btn-md rounded font-sm">
                                    Detail
                                  </a> */}
                            <div class="dropdown">
                              <a
                                href="#"
                                data-bs-toggle="dropdown"
                                class="btn btn-light rounded btn-sm font-sm"
                              >
                                <i class="material-icons md-more_horiz"></i>
                              </a>
                              <div class="dropdown-menu">
                                <a
                                  class="dropdown-item"
                                  href={`/order/details/${props.orderId}`}
                                >
                                  View detail
                                </a>
                                {/* <a class="dropdown-item" href="#">
                                        Edit info
                                      </a> */}
                                <a class="dropdown-item text-danger" href="#">
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <div>No order Found</div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* <div class="pagination-area mt-30 mb-50">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-start">
              <li class="page-item active">
                <a class="page-link" href="#">
                  01
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  02
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  03
                </a>
              </li>
              <li class="page-item">
                <a class="page-link dot" href="#">
                  ...
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  16
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  <i class="material-icons md-chevron_right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div> */}
        {/* <div class="pagination-area mt-30 mb-50">
          <nav aria-label="Page navigation example">
          <ReactPaginate
              nextLabel="Next"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="Previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link w-auto"
              nextClassName="page-item"
              nextLinkClassName="page-link w-auto"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-start"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </nav>
        </div> */}
      </section>
    </>
  );
};

export default DashboardIndex;
